module.exports = __webpack_public_path__ + "img/KEBUKE Tea.9e69a91f.svg";